import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getSingleProject } from '../Common/apis';
import { toast } from 'react-toastify';
import Loader from '../Components/Loader/Loader';
import moment from 'moment';

function Foundation() {
    const { id } = useParams();

    const [project, setAllProject] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchProject = async () => {
        setLoading(true);
        try {
            const response = await getSingleProject(id);
            setAllProject(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (id) {
            fetchProject();
        }
    }, [id]);

    return (
        <>
            {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='lg:px-[104px] px-[30px] pt-[50px] md:pb-[120px] pb-[40px]'>
                    {project &&
                        <div className="relative md:pb-[136px] pb-[30px]">
                            <img src={project?.Image} className='w-full h-[483px] object-cover rounded-[16px]' alt="" />
                            <div className='rounded-[30px] md:absolute relative md:bottom-[70px] bottom-[unset] left-[50%] translate-x-[-50%] max-w-[1071px] w-full mx-auto py-[8px] px-[10px]' style={{ background: "linear-gradient(180deg, #FF6000 0%, #F68B29 100%)" }}>
                                <div className='bg-[#FFFFFF] rounded-[26px] py-[20px] px-[40px]'>
                                    <h6 className="md:text-[40px] text-[20px] font-[700] font-manrope text-[#333333] pb-[16px]">{project?.ProjectName}</h6>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-[10px]">
                                            <img src={project?.UserImage} className='h-[52px] w-[52px] object-cover rounded-full' alt="" />
                                            <p className="font-[400] font-manrope text-[#666666] text-[16px]">{project?.UserName}</p>
                                        </div>
                                        <p className="font-[500] font-manrope text-[#FF6000] text-[16px]">{moment(project?.createdAt).format("DD-MM-YYYY")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="flex md:gap-[90px] justify-center gap-[40px] md:flex-row flex-col">
                        <div className='max-w-[732px] w-full flex flex-col md:gap-[36px] gap-[20px]'>
                            <h6 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#333333]">Supporting Health Initiatives</h6>
                            <p className="font-[500] tracking-[1.5px] text-[16px] leading-[34px] font-manrope text-[#000000]">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galltype and scrambled it to make a type specimen book. It has survived not only five centuries tinto electronic typesetting remaining essentially unchanged <br />
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown print
                            </p>
                            <ul className='list-disc pl-[20px]'>
                                <li className='font-[600] font-manrope text-[24px] leading-[34px] text-[#333333]'>Hope Restoration</li>
                                <li className='font-[600] font-manrope text-[24px] leading-[34px] text-[#333333]'>Giving Back</li>
                                <li className='font-[600] font-manrope text-[24px] leading-[34px] text-[#333333]'>Positive Impact</li>
                            </ul>
                            <h6 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#333333]">Elevate Your Business with IT Solutions</h6>
                            <p className="font-[500] tracking-[1.5px] text-[16px] leading-[34px] font-manrope text-[#000000]">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galltype and scrambled it to make a type specimen book. It has survived not only five centuries tinto electronic typesetting remaining essentially unchanged</p>
                        </div>
                        <div className='pt-[20px] flex flex-col gap-[30px]'>
                            <img src="/assets/gallery/img9.png" alt="" />
                            <img src="/assets/gallery/img8.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Foundation